import PropTypes from "prop-types";
import { IconButton, Tooltip } from "@mui/material";
import { RefreshCw } from "lucide-react";

const REFRESH_BTN_SX = {
  width: "40px",
  height: "40px",
  backgroundColor: "transparent",
  color: "var(--color-text-header, rgba(0, 0, 0, 0.87))",
};

/**
 * Reusable refresh icon button with dark-theme support.
 *
 * @param {function} onClick   – callback fired on click
 * @param {string}   [tooltip] – tooltip text (default "Refresh")
 * @param {boolean}  [disabled] – disable the button
 * @param {number}   [size]    – icon size in px (default 20)
 * @param {object}   [sx]      – additional MUI sx overrides
 */
export default function RefreshButton({ onClick, tooltip = "Refresh", disabled = false, size = 20, sx = {} }) {
  return (
    <Tooltip title={tooltip}>
      <span>
        <IconButton onClick={onClick} disabled={disabled} sx={{ ...REFRESH_BTN_SX, ...sx }}>
          <RefreshCw size={size} />
        </IconButton>
      </span>
    </Tooltip>
  );
}

RefreshButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  tooltip: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.number,
  sx: PropTypes.object,
};
